export function getDefaultAggregatorPreference(
  defaultAggregatorOverride: string | null | undefined,
  defaultAggregatorPreference: string | null | undefined,
): string {
  if (defaultAggregatorOverride && defaultAggregatorOverride !== 'USE_PREFERENCE_SERVICE') {
    return defaultAggregatorOverride;
  }
  return defaultAggregatorPreference ? defaultAggregatorPreference.toUpperCase() : 'FDP';
}
